<template src="./ProductComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {useAccountStore} from "@/stores/account.js";
import {AppConstant, CommonText} from "@/supports/app.constant";
import {ref, onMounted, computed, watch, reactive} from "vue";
import CommonService from "@/services/common.service.ts";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import {useRouter} from "vue-router";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import {useProductStore} from "@/stores/product.js";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import SelectCustom from "@/components/inputs/select/custom/SelectCustom.vue";
import ModalDeliveryProductListComponent
  from "@/components/modals/modal-delivery-product-list/ModalDeliveryProductListComponent.vue";
import ModalProductExportComponent from "@/components/modals/modal-export/ModalExportComponent.vue";
import LoadingComponent from "@/components/loading/LoadingComponent.vue";
import ModalProductImportComponent from "@/components/modals/modal-product-import/ModalProductImportComponent.vue";
import ModalExportComponent from "@/components/modals/modal-export/ModalExportComponent.vue";
import {useScreenSize} from "@/composable/useScreenSize.js";
import IconSort from "@/components/icons/IconSort.vue";
import IconArrowDown from "@/components/icons/IconArrowDown.vue";
import IconArrowUp from "@/components/icons/IconArrowUp.vue";
import ErrorMessageService from "@/services/error-message.service.js";

export default {
  name: 'ProductComponent',
  components: {
    IconArrowUp,
    IconArrowDown,
    IconSort,
    ModalExportComponent,
    ModalProductImportComponent,
    LoadingComponent,
    ModalProductExportComponent,
    ModalDeliveryProductListComponent,
    SelectCustom,
    InputCheckboxOne,
    PaginateComponent,
    ButtonAddComponent,
    IconTrash,
    IconEdit,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome},
  setup() {
    const dataHeaderTable =  ref({
      product_name: {
        label: 'Tên sản phẩm',
        order: 1,
        width: '20%',
        sort: 1
      },
      product_code: {
        label: 'Mã sản phẩm',
        order: 2,
        width: '10%',
        sort: 1
      },
      product_quantity: {
        label: 'Số lượng sản phẩm',
        order: 3,
        width: '12%',
        sort: 1
      },
      product_price: {
        label: 'Giá sản phẩm',
        order: 5,
        width: '10%',
        sort: 1
      },
      productSellingPrice: {
        label: 'Giá bán sản phẩm',
        order: 6,
        width: '10%',
      },
      // productUnit: {
      //   label: 'Đơn vị sản phẩm',
      //   order: 7,
      //   width: '10%',
      //   sort: 1
      // },
      product_tax: {
        label: 'Thuế',
        order: 8,
        width: '10%',
        sort: 1
      },
      warehouse: {
        label: 'Kho hàng',
        order: 9,
        width: '10%',
      },
    })
    const labelButtonSearch = ref('Tìm kiếm')
    const labelButtonCreate = ref('Tạo sản phẩm')
    const labelButtonImport = ref('Nhập file sản phẩm')
    const urlOrigin = ref('/product/list/')
    const dataSearch = ref({
      product_name: {
        id: 'product_name',
        label: 'Tên sản phẩm',
        placeholder: 'Tên sản phẩm',
        value: '',
        required: false
      },
      product_code: {
        id: 'product_code',
        label: 'Mã sản phẩm',
        placeholder: 'Mã sản phẩm',
        value: '',
        required: false
      },
    })
    const checkAll = ref(false)
    const checkItems = ref({})
    const listItemSelected = ref([])
    const eventClickShowModalExport = ref(false)
    const eventClickShowModalImport = ref(false)
    const listProductsSelected = ref([])
    const errorMessage = ref([])
    const isLoading = ref(false)
    const location = ref('Sản phẩm')
    const table = ref('product')
    const { widthScreen, isSmallScreen } = useScreenSize(1024);
    const selectAction = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_ACTION_PRODUCT))
    const selectLimitPage = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_ACTION_PAGE))

    const stateModal = reactive({
      modalExportFile: null,
      modalImportFile: null,
    })
    const productStore = useProductStore()
    const accountStore = useAccountStore()
    const router = useRouter()

    onMounted(() => {
      stateModal.modalExportFile = new bootstrap.Modal('#modalExport', {})
      stateModal.modalImportFile = new bootstrap.Modal('#modalProductImport', {})
      getListProduct(router.currentRoute.value.query.page ?? 1);
    });

    const listKeySort = computed(() =>
        Object.entries(dataHeaderTable.value)
            .filter(([_, v]) => v.sort !== undefined)
            .map(([key, v]) => ({ key, sort: v.sort }))
    )

    const listProducts = computed(() => {
      return productStore.products;
    });
    const paginate = computed(() => {
      return productStore.paginate;
    });

    function emitPage(page) {
      getListProduct(page);
    }
    function redirectToCreate() {
      router.push('/product/create')
    }

    function getListProduct(page, take = 10) {
      const params = {
        id: accountStore.account.company.id,
        product_name: dataSearch.value.product_name.value,
        product_code: dataSearch.value.product_code.value,
        sort: listKeySort.value,
        page: page,
        take: take,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/product/product-list';
      productStore.getListProducts(url, params);
    }

    watch(() => productStore.products, (newListProducts) => {
      newListProducts.forEach((product) => {
        if(checkItems.value[product.id] === undefined) {
          checkItems.value[product.id] = false
        }
      })
    });
    function searchProducts() {
      getListProduct(1);
    }

    function onChange(value, name) {
      dataSearch.value[name].value = value;
    }

    function onChangeSelectAll(value) {
      checkAll.value = value
      for (const key in checkItems.value) {
        checkItems.value[key] = value
      }
      if(!value) {
        listItemSelected.value = []
      }else {
        listProducts.value.forEach((product) => {
          if(listItemSelected.value.indexOf(product.id) === -1) {
            listItemSelected.value.push(product.id)
          }
        })
      }
    }

    function onChangeSelectItem(value, name) {
      checkItems.value[name] = value
      let counterChecked = 0
      listProducts.value.forEach((product) => {
        if(checkItems.value[product.id]) {
          counterChecked++
        }
        if(value && listItemSelected.value.indexOf(product.id) === -1 && parseInt(name) === parseInt(product.id)) {
          listItemSelected.value.push(product.id)
        }else if (!value && listItemSelected.value[product.id]) {
          listItemSelected.value.splice(listItemSelected.value.indexOf(product.id), 1);
        }
      })
      checkAll.value = false
      if(counterChecked === listProducts.value.length) {
        checkAll.value = true
      }
    }
    function actionSelect(key) {
      if(listItemSelected.value.length === 0) {
        CommonService.showAlertPopup({
          title: 'Vui lòng chọn dữ liệu để thực hiện!',
          icon: "warning",
          showConfirmButton: false,
          timer: 1500,
          width: '800px'
        });
      }else {
        switch (parseInt(key)) {
          case AppConstant.ACTION_TYPE_DELETE:
            deleteProduct();
            break;
          case AppConstant.ACTION_TYPE_EXPORT_EXCEL:
            exportExcel();
            break;
        }
      }
    }

    async function actionLimitPage(key) {
      switch (parseInt(key)) {
        case AppConstant.LIMIT_PAGE_10:
          await getListProduct(1, AppConstant.LIMIT_PAGE_10);
          break;
        case AppConstant.LIMIT_PAGE_20:
          await getListProduct(1, AppConstant.LIMIT_PAGE_20);
          break;
        case AppConstant.LIMIT_PAGE_50:
          await getListProduct(1, AppConstant.LIMIT_PAGE_50);
          break;
      }
    }

    async function deleteProduct() {
      const params = {
        company_id: accountStore.account.company.id,
        product_ids: listItemSelected.value,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/product/delete';
      const res = await CommonService.__delete(params, url, productStore);
      const errorMessageRes = await ErrorMessageService.getErrorMessage(res)
      if(errorMessageRes !== undefined && errorMessageRes.length > 0) {
        errorMessage.value = typeof errorMessageRes === 'string' ? [errorMessageRes] : errorMessageRes;
      } else {
        await CommonService.showAlertPopup({
          title: res?.message,
          icon: res?.status,
          showConfirmButton: false,
          timer: 1200,
          width: '800px'
        });
        if(res?.status === 'success') {
          productStore.products = productStore.products.filter(item => !listItemSelected.value.includes(item.id))
          productStore.paginate.itemCount -= listItemSelected.value.length
        }
      }
    }

    async function exportExcel() {
      settingExportFields()
    }

    function settingExportFields() {
      showModalExport()
    }

    function sortProducts(key) {
      dataHeaderTable.value[key].sort = dataHeaderTable.value[key].sort === 1 ? -1 : 1
      getListProduct(1)
    }

    function eventShowModalExport(isShow) {
      if(isShow) {
        setTimeout(function () {
          eventClickShowModalExport.value = false
          isLoading.value = false
          stateModal.modalExportFile.show()
        }, 1000);
        return;
      }
      checkAll.value = false
      listProducts.value.forEach((item) => {
        checkItems.value[item.id] = false
      })
      listProductsSelected.value = []
      stateModal.modalExportFile.hide()
    }
    function showModalImportProduct(isShow) {
      if(isShow) {
        setTimeout(function () {
          eventClickShowModalImport.value = false
          isLoading.value = false
          stateModal.modalImportFile.show()
        }, 1000);
        return;
      }
      stateModal.modalImportFile.hide()
    }

    function showProductDetail(productId) {
      router.push('/product/detail/' + productId)
    }

    function showModalExport () {
      eventClickShowModalExport.value = true
      isLoading.value = true
    }

    function importProduct() {
      eventClickShowModalImport.value = true
      isLoading.value = true
    }

    function showErrorMessage(mess) {
      errorMessage.value = [mess]
    }

    function removeError(key) {
      errorMessage.value.splice(key, 1)
    }

    return {
      listProducts,
      dataHeaderTable,
      labelButtonSearch,
      labelButtonCreate,
      labelButtonImport,
      dataSearch,
      paginate,
      urlOrigin,
      checkAll,
      listItemSelected,
      checkItems,
      selectAction,
      selectLimitPage,
      eventClickShowModalExport,
      eventClickShowModalImport,
      listProductsSelected,
      isLoading,
      errorMessage,
      location,
      table,
      widthScreen,
      isSmallScreen,
      onChangeSelectAll,
      onChangeSelectItem,
      emitPage,
      redirectToCreate,
      searchProducts,
      onChange,
      actionSelect,
      eventShowModalExport,
      showModalImportProduct,
      actionLimitPage,
      importProduct,
      showErrorMessage,
      removeError,
      showProductDetail,
      sortProducts,
      CommonText,
      CommonService,
    }
  },
}
</script>
<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 80px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        .btn-invite-partner {
          width: 150px;
          margin-top: 50px;
        }
        .list-products-component {
          margin-top: 30px;
          .label_priority {
            padding: 5px;
            border: 1px solid #f73164;
            border-radius: 5px;
            max-width: 120px;
            width: 120px;
            display: flex;
            align-content: center;
            justify-content: center;
            color: #ffffff;
          }
          .sort {
            cursor: pointer;
          }
          td.action {
            display: flex;
            justify-content: center;
            gap: 20px;
            .item-action {
              width: 20px;
              cursor: pointer;
            }
          }
          td.product-name {
            max-width: 500px;
            p {
              overflow-y: hidden;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              line-clamp: 1;
              -webkit-box-orient: vertical;
              margin: 0;
              text-decoration: underline;
              cursor: pointer;
            }
          }
        }

      }
    }
  }
}
</style>
